<template>
  <div class="detailPage">
    <div class="banner">
      <img :src="form.goods_thumb_full" />
      <div class="share" @click="showShare = true"></div>
    </div>
    <!-- 拼团未结束的状态 -->
    <div class="main" v-show="sh">
      <div class="left">
        <span class="price">¥{{forms.shopgroup_joinprice}}</span>
        <span class="oldPrice">¥{{form.shop_price}}</span>
      </div>
      <!-- <div class="group">
        <div class="icon"></div>
        <div class="span1">{{forms.shopgroup_joinnumber}}人成团</div>
      </div>-->
      <div class="right">
        <div class="prompt">
          <div class="img"></div>
          <div class="time">
            <span>距离结束时间仅剩：</span>
          </div>
        </div>
        <van-count-down :time="time">
          <template v-slot="timeData">
            <span class="currentday">{{ timeData.days }}</span>
            天
            <span class="currentday">{{ timeData.hours }}</span>
            :
            <span class="currentday">{{ timeData.minutes }}</span>
            :
            <span class="currentday">{{ timeData.seconds }}</span>
          </template>
        </van-count-down>
      </div>
    </div>
    <!-- 拼团结束的状态 -->
    <div class="main" style="background: #D8D8D8" v-show="shw">
      <div class="left">
        <span class="price" style="color: #fff">¥{{forms.shopgroup_joinprice}}</span>
        <span class="oldPrice">¥{{form.shop_price}}</span>
      </div>
      <!-- <div class="group">
        <div class="icon"></div>
        <div class="span1">{{forms.shopgroup_joinnumber}}人成团</div>
      </div>-->
      <div class="right" style="background: #BEBEBE">
        <div class="prompt">
          <div class="img"></div>
          <div class="time">
            <span>距离结束时间仅剩：</span>
          </div>
        </div>
        <p>拼团活动结束</p>
      </div>
    </div>
    <!-- 团详情 -->
    <div class="course">
      <p>{{forms.shopgroup_title}}</p>
      <span>{{forms.shopgroup_projectname}}</span>
      <span>|</span>
      <span>{{forms.shopgroup_count}}人已成团</span>
      <br />
      <span>课程有效期至：</span>
      <span>{{forms.shopgroup_endtime}}</span>
    </div>
    <div class="feature">
      <p>课程特色：</p>
      <span>{{forms.shopgroup_desc}}</span>
    </div>
    <div class="team" v-show="ow">
      <div class="teamTop">
        <span>{{grouplist.length}}人正在拼团可直接参与</span>
        <div class="looking" @click="all" v-if="grouplist.length > 1">
          <span class="looks">查看全部 ></span>
        </div>
      </div>
      <!-- 滚动组件 -->
      <!-- <div class="teambot"> -->
      <vue-seamless-scroll
        v-if="grouplist.length>2"
        :data="grouplist"
        class="seamless-warp"
        :class-option="options"
      >
        <ul class="item">
          <li class="teamBottom" v-for="(item,index) in grouplist" :key="index">
            <div class="design"></div>
            <div class="mobile">
              <span>{{item.usergroup_sponsorphone}}</span>
            </div>
            <div class="meddie">
              <span>还剩</span>
              <span class="pople">{{shopgroup_joinnumber - item.usergroup_placeholder}}人</span>
              <span>拼成</span>
              <br />
              <span>剩余:</span>
              <van-count-down class="timing" :time="time" />
            </div>
            <div class="button" @click="goes(item)">去参团</div>
          </li>
        </ul>
      </vue-seamless-scroll>
      <div v-else class="seamless-warp">
        <ul class="item">
          <li class="teamBottom" v-for="(item,index) in grouplist" :key="index">
            <div class="design"></div>
            <div class="mobile">
              <span>{{item.usergroup_sponsorphone}}</span>
            </div>
            <div class="meddie">
              <span>还剩</span>
              <span class="pople">{{shopgroup_joinnumber - item.usergroup_placeholder}}人</span>
              <span>拼成</span>
              <br />
              <span>剩余:</span>
              <van-count-down class="timing" :time="time" />
            </div>
            <div class="button" @click="goes(item)">去参团</div>
          </li>
        </ul>
      </div>
      <!-- </div> -->
    </div>
    <div class="introduce">
      <van-tabs sticky scrollspy>
        <van-tab title="课程介绍">
          <div class="look" v-html="form.goods_desc"></div>
        </van-tab>
        <van-tab title="学员评价">
          <div class="evaluation">
            <div class="teamTop">
              <span>学员评价</span>
              <div class="looking" @click="complete" v-if="list.lenth > 1 ">
                <span class="looking">全部评价 ></span>
              </div>
            </div>
            <div class="default" v-if="list.length === 0"></div>
            <p class="p" v-if="list.length === 0">暂无学员评价哦</p>
            <div class="student" v-for="item in list" :key="item.comment_id">
              <div class="icon"></div>
              <span class="mobile">{{item.comment_mobilephone}}</span>
              <span class="time">{{item.comment_addtime}}</span>
              <van-rate class="comment" v-model="item.comment_rank" />
              <p class="ping">{{item.comment_content}}</p>
            </div>
          </div>
        </van-tab>
      </van-tabs>
    </div>
    <div class="footers">
      <div class="footer">
        <ul>
          <li class="consult">
            <!-- <div class="icon"></div> -->
             <p><a href="tel:400-821-0721">400-821-0721</a></p>
            <p>咨询电话</p>
          </li>
          <li class="buyer" v-show="showng" @click="direct">
            <p class="p1">¥{{form.shop_price}}</p>
            <p>直接购买</p>
          </li>
          <li class="sponsor" @click="group" v-show="shows">
            <p class="p2">¥{{forms.shopgroup_joinprice}}</p>
            <p>发起拼团</p>
          </li>
          <li class="looksing" v-show="showing" @click="mygroup">查看我的团</li>
          <li class="looksing" v-show="showsing" @click="study">进入学习</li>
          <li class="looksing" v-show="cause" style="line-height: 1.4rem" @click="purchase">
            <p class="p1">¥{{form.shop_price}}</p>
            <p>原价直接购买</p>
          </li>
        </ul>
      </div>
    </div>
    <!-- 电话弹框 -->
    <van-dialog v-model="showDialog" title="咨询电话" show-cancel-button>
        <div style="text-align:center;margin-bottom:10px">
          <p><a href="tel:400-821-0721">400-821-0721</a></p>
        </div>
   </van-dialog>
    <!-- 分享弹框 -->
    <van-popup
      v-model="showShare"
      :style="{ height: '100%', width: '100%',backgroundColor:'rgba(0,0,0,0.6)' }"
    >
      <van-image :src="shareBgSrc1" width="100%"></van-image>
      <van-image @click="showShare = !showShare" :src="shareBgSrc2" style="margin-left:20%;"></van-image>
    </van-popup>
    <!-- 全部拼团弹框 -->
    <van-popup v-model="show" closeable round>
      <div class="pt">正在拼团</div>
      <div class="now">
        <div class="teamBottom" v-for="item in grouplist" :key="item.usergroup_id">
          <div class="design"></div>
          <div class="mobile">
            <span>{{item.usergroup_sponsorphone}}</span>
          </div>
          <div class="meddie">
            <span>还剩</span>
            <span class="pople">{{shopgroup_joinnumber - item.usergroup_placeholder}}人</span>
            <span>拼成</span>
            <br />
            <span>剩余:</span>
            <van-count-down class="timing" :time="time" />
          </div>
          <div class="button" @click="goes(item)">去参团</div>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import {api_group,api_goods} from '@/common/Request.js';
import wx from "weixin-js-sdk";
import vueSeamlessScroll from "vue-seamless-scroll";
import Utils from "../common/weixin";
import { Dialog } from "vant";
export default {
  components: {
    vueSeamlessScroll
  },
  data() {
    return {
      form: {
        goods_thumb: "",
        goods_thumb_full: "",
        shop_price: ""
      },
      top: '',
      ow:true,
      cause: false,
      shw: false,
      sh: true,
      show: false,
      showShare: false,
      shareBgSrc1: require("../assets/share1.png"),
      shareBgSrc2: require("../assets/share2.png"),
      shopgroup_id: "",
      forms: {},
      goods_id: "",
      // forms: {},
      list: [],
      // token: "MjI2NywxNTg3NjA3NzU4LDE4ODYyMTAxNDk4",
      token: "",
      lists: {
        order_id: "",
        order_sn: "",
        order_amount: "",
        usergroup_id: ""
      },
      // 拼团成员
      grouplist: [
        {
          usergroup_id: "",
          usergroup_placeholder: "",
          usergroup_sponsor: "",
          usergroup_sponsorname: "",
          usergroup_sponsorphone: "",
          usergroup_starttime: "",
          usergroup_status: ""
        }
      ],
      showDialog: false,
      // 是否加载
      loading: false,
      // 弹框列表
      popupList: [],
      isactive: true,
      time: "",
      times: "",
      showing: false,
      shows: false,
      showng: false,
      showsing: false,
      shopgroup_joinnumber: "",
      order_sn: "",
      order_time: "",
      usergroup_completecount: "",
      options: {
        step: 0.5,
        waitTime: 2000,
        hoverStop: false,
        limitMoveNum: 3,
        dircection: 1,
        autoPlay: true
      },
      starttime: '',
      endtime: ''
    };
  },
  mounted() {
    // this.top = 0
    this.scrollWindow();
  },
  created() {
    let self = this;
    //初始化wx配置
    Utils.initWXConfig(this, function() {
      //callback
      wx.hideAllNonBaseMenuItem();
      wx.showMenuItems({
        menuList: ["menuItem:share:appMessage", "menuItem:share:timeline"] // 要隐藏的菜单项，只能隐藏“传播类”和“保护类”按钮，所有menu项见附录3
      });
      //init shareconfig

      let shareConfig = self.initShareConfig();
      Utils.updateWxShareMenu(shareConfig);
    });
    this.getList();
    this.updataGroup();
    this.somelist();
    this.userList();
    //  this.personList()
  },

  methods: {
    scrollWindow(){
window.scrollTo(0,0);
},
    initShareConfig() {
      // console.log("location",window.location.href);
      let config = {
        link: window.location.href,
        title: this.forms.shopgroup_title,
        desc: "这个课程真是优惠，快来看看！",
        imgUrl: this.forms.shopgroup_img
      };
      // console.log('zzz',config);

      return config;
    },
    // 进入页面调用接口
    updataGroup() {
		api_group.group_statusscan().then(res => {
        // console.log(res)
      });
    },
    // 拼团列表
    somelist() {
		api_group.usergroup_list(100,0,this.shopgroup_id).then(res => {
        // console.log("res", res);
        for (var i = 0; i < res.data.length; i++) {
          // res.data[i].comment_rank = Number( res.data[i].comment_rank)
          var mystr = String(res.data[i].usergroup_sponsorphone);
          res.data[i].usergroup_sponsorphone =
            mystr.substr(0, 3) +
            "****" +
            mystr.substr(7, mystr.split("").length);
        }

        this.grouplist = res.data;
        // console.log(this.grouplist)
      });
    },
    // 获取用户团购的状态/获取用户当前的订单号和下单时间
    userList() {
      this.token = this.$cookies.get("user_token");
	  api_group.get_usershopgroup_status(this.shopgroup_id,this.token).then(res => {
        // console.log('res',res.data.usershopgroupstatus.usergroupmember_status)
        // console.log("1111", res);
        this.order_sn = res.data.order_sn;
        this.order_time = res.data.order_time;
        this.usergroup_completecount = res.data.usergroup_completecount;
        if (
          res.data.usershopgroupstatus == 0 ||
          res.data.usershopgroupstatus == undefined
        ) {
          this.showng = true;
          this.shows = true;
          // const starttime = (new Date()).valueOf();
          if(this.starttime > this.endtime) {
            this.shows = false
            this.showng = false
            this.showing = false
            this.showsing = false
            this.cause = true
          }
          // console.log('userlist',this.shows);

        }
        if (
          res.data.usershopgroupstatus == 2 ||
          res.data.usershopgroupstatus == 1
        ) {
          this.showing = true;
        }
        if (res.data.usershopgroupstatus == 3) {
          this.showsing = true;
        }
      });
    },
    // 咨询电话
    // consultService() {
      // Dialog.alert({
      //   title: "咨询热线",
      //   message: <html><a href="tel:110">别过来，我报警了！！！</a></html>
      // }).then(() => {
      // });
    //   this.showDialog = true
    // },
    // 直接购买拼团商品
    direct() {
      const id = this.forms.shopgroup_goodsid;
      this.$router.push({ path: "goods_detail", query: { goodsid: id } });
    },
    // 活动结束直接购买
    purchase() {
      const id = this.forms.shopgroup_goodsid;
      this.$router.push({ path: "goods_detail", query: { goodsid: id } });
    },
    // 创建拼团团队并加入
    group() {
      const id = this.forms.shopgroup_id;
      this.token = this.$cookies.get("user_token");
	  api_group.usergroup_creategroup(this.shopgroup_id,this.token).then(res => {
        if (res.code === 0) {
          this.lists = res.data;
          //  console.log('wwww',res)
          this.$router.push({
            path: "payment_group",
            query: {
              shopgroup_id: id,
              order_id: this.lists.order_id,
              order_amount: this.lists.order_amount,
              order_sn: this.lists.order_sn
            }
          });
        }
        if (res.code === 1) {
          alert("请登录");
        }
        if (res.code === 2) {
          alert("团购活动id不存在");
        }
        if (res.code === 3) {
          alert("您已创建该团购活动的拼团无法再次创建");
          // this.showing = true
          // this.cause = false
        }
      });
    },
    // 获取用户当前的订单号和下单时间
    // personList() {
    //    const id = this.forms.shopgroup_id
    //   this.$jsonp('http://v.huazhi.cn/slim' + '/app_v1/group/get_usershopgroup_status/'+this.shopgroup_id+'/'+this.token).then(res=>{
    //     console.log('ww',res);

    //   })
    // },
    // 进入学习
    study() {
      const id = this.forms.shopgroup_goodsid;
      this.$router.push({ path: "goods_detail", query: { goodsid: id } });
    },
    all() {
      this.show = true;
    },
    // 团队活动详情
    getList() {
      this.shopgroup_id = this.$route.query.shopgroup_id;
	  api_group.shopgroup_detail(this.shopgroup_id).then(res => {
        this.forms = res.data;
        this.goods_id = res.data.shopgroup_goodsid;
        const starttime = (new Date()).valueOf();
        // alert(starttime);
        this.starttime = starttime
        const endtime = (new Date(this.formatstr(res.data.shopgroup_endtime))).valueOf();
        // alert(endtime);
        this.endtime = endtime
        // console.log(this.endtime)
        if ((starttime - endtime) > 0) {
          // console.log( this.showsing)
          this.showsing = false;
          this.showng = false;
          this.shw = true;
          this.sh = false;
          this.ow = false
          this.showsing = false
          this.cause = true;
           this.shows = false;
            // console.log('shows',this.shows);
        }
        const time = endtime - starttime;
        this.time = time;
        this.times = time;
        //alert(this.time);
        // console.log(this.times);
        // console.log(res.data)
        this.shopgroup_joinnumber = res.data.shopgroup_joinnumber;
        this.setList();
        this.studentList();
      });
    },
    setList() {
		api_goods.goods_detail(this.goods_id).then(res => {
        this.form = res.data;
      });
    },
    // 学员评价
    studentList() {
		api_goods.goods_comment(100,0,this.goods_id).then(res => {
        for (var i = 0; i < res.data.length; i++) {
          res.data[i].comment_rank = Number(res.data[i].comment_rank);
          var mystr = String(res.data[i].comment_mobilephone);
          res.data[i].comment_mobilephone =
            mystr.substr(0, 3) +
            "****" +
            mystr.substr(7, mystr.split("").length);
        }
        this.list = res.data;
      });
    },
    complete() {
      const id = this.goods_id;
      this.$router.push({ path: "all_evaluation", query: { good_id: id } });
    },
    goes(item) {
      // console.log(item);
      // this.$router.push({path:'payment'})
      const id = item.usergroup_id;
      this.token = this.$cookies.get("user_token");
	  api_group.usergroup_joingroup(id,this.token).then(res => {
        if (res.code === 0) {
          // console.log(res);
          this.lists = res.data;
          this.$router.push({
            path: "payment_group",
            query: {
              shopgroup_id: this.shopgroup_id,
              order_id: this.lists.order_id,
              order_amount: this.lists.order_amount,
              order_sn: this.lists.order_sn
            }
          });
        }
        if (res.code == 5) {
          Dialog.alert({
            message: "你已经参团"
          }).then(() => {
            // on close
			this.$router.push({
			  path: "my_group",
			  query: {
			    statustype: 2
			  }
			});
          });
        }
        // console.log('res',res)
      });
    },
    mygroup() {
      const id = this.shopgroup_id;
      // console.log(id)
      this.$router.push({
        path: "group_detail",
        query: {
          shopgroup_id: id,
          order_sn: this.order_sn,
          order_time: this.order_time,
          usergroup_completecount: this.usergroup_completecount
        }
      });
    },
    formatstr(timestr)
    {
       timestr=timestr.replace(/-/g,"/");
       return timestr;
    }
  }
};
</script>

<style scoped>
.detailPage {
  /* position: relative; */
  background-color: #f3f3f3;
  overflow: hidden;
}
.van-share-sheet__options {
  padding: 16px 0 16px 110px;
}
.banner {
  position: relative;
  width: 100%;
  height: 13.4375rem /* 215/16 */;
  /* background-color: pink; */
}
.banner img {
  width: 100%;
  height: 13.4375rem /* 215/16 */;
}
.share {
  position: absolute;
  top: 1.25rem /* 20/16 */;
  right: 1.25rem /* 20/16 */;
  width: 1.375rem /* 22/16 */;
  height: 1.375rem /* 22/16 */;
  /* background-color: #000; */
  background: url("/img/fenxiang.png") no-repeat;
  /* background-size: 1.375rem 1.375rem; */
  background-size: 100% 100%;
}
.main {
  width: 100%;
  height: 4rem /* 64/16 */;
  background-color: #fe5a59;
}
.price {
  font-size: 1.1875rem /* 19/16 */;
  color: #fedeaf;
  font-weight: 700;
  line-height: 4rem;
  margin-left: 0.625rem /* 20/16 */;
}
.oldPrice {
  line-height: 4rem;
  font-size: 0.75rem /* 12/16 */;
  color: #fff;
  text-decoration: line-through;
  margin-left: 0.3125rem /* 5/16 */;
}
.left {
  float: left;
}
.group {
  height: 1.25rem /* 20/16 */;
  width: 4.125rem /* 65/16 */;
  background-color: #ffd597;
  display: inline-block;
  font-size: 0.3125rem /* 5/16 */;
  border-radius: 1.46875rem /* 7.5/16 */;
  margin-left: 1rem /* 40/16 */;
  line-height: 0.9375rem;
  padding-left: 0.125rem /* 10/16 */;
  margin-top: 1.5rem /* 10/16 */;
}
.group .icon {
  display: inline-block;
  height: 1.375rem /* 22/16 */;
  width: 1.375rem /* 22/16 */;
  background: url("/img/pople.png") no-repeat;
  background-size: 100% 100%;
}
.group .span1 {
  float: right;
  margin-top: 0.25rem /* 4/16 */;
  margin-right: 0.3125rem /* 10/16 */;
  color: #fe5a59;
  font-size: 0.3125rem /* 8/16 */;
}
.right .img {
  display: inline-block;
  background: url("/img/naozhong.png") no-repeat;
  height: 1.25rem /* 20/16 */;
  width: 1.25rem /* 20/16 */;
  background-size: 100% 100%;
  /* float: left; */
  margin-top: 0.3125rem /* 5/16 */;
}
.right {
  box-sizing: border-box;
  padding-top: 0.625rem /* 10/16 */;
  float: right;
  background-color: #ff3635;
  width: 9.5625rem /* 153/16 */;
  height: 100%;
  padding-left: 0.625rem;
}
.timing {
  display: inline-block;
  font-size: 0.75rem /* 14/50 */;
}
.right ::v-deep .currentday {
  display: inline-block;
  width: 1.25rem;
  background-color: #fff;
  height: 1.25rem;
  text-align: center;
  color: #ff3635;
  /* line-height: 1.25rem; */

  font-size: 1rem;
}
.pople {
  color: #ff3635;
}
.right .prompt {
  display: flex;
}
.seamless-warp {
  height: 9.2rem /* 150/50 */;
  overflow: hidden;
}
.right p {
  color: #fff;
  /* text-align: center; */
}
.right img {
  height: 1.375rem /* 22/16 */;
  width: 1.375rem /* 22/16 */;
}
.right .time {
  float: right;
  margin-right: 0.75rem /* 20/16 */;
}
.right span {
  /* vertical-align: middle; */
  color: #fff;
  font-size: 0.5625rem /* 9/16 */;
}
.course {
  height: 5.9375rem /* 95/16 */;
  background-color: #fff;
  padding-top: 0.9375rem /* 15/16 */;
  padding-left: 0.9375rem /* 15/16 */;
}
.course p {
  font-weight: 700;
  font-size: 0.875rem /* 14/16 */;
  color: #333333;
}
.course span {
  color: #a9a9a9;
  font-size: 0.75rem /* 12/16 */;
}
.feature {
  height: auto /* 60/16 */;
  /*width: 100%;*/
  background-color: #fff;
  margin-top: 0.3125rem /* 5/16 */;
  padding-left: 0.9375rem;
  padding-right:0.9375rem;
  padding-top: 0.3125rem /* 5/16 */;
  padding-bottom: 0.3125rem /* 5/16 */;
}
.feature p {
  font-size: 0.875rem /* 14/16 */;
}
.feature span {
  color: #666666;
  font-size: 0.75rem /* 12/16 */;
}
.team {
  margin-top: 0.3125rem /* 5/16 */;
  height: 11.5625rem /* 185/16 */;
  background-color: #fff;
  width: 100%;
}
.teambot {
  height: 3rem /* 150/50 */;
}
/* 拼团详情 */
.teamMain {
  display: flex;
  padding-left: 1.15625rem;
  align-items: center;
  height: 3.125rem;
  border-bottom: 1px green solid;
}
.teamMain .regiment {
  width: 3.75rem;
  height: 1.5rem;
  font-size: 12px;
  text-align: center;
  line-height: 1.5rem;
  background-color: red;
  margin-left: 1rem;
  color: #fff;
}
.teamMain .gap {
  font-size: 0.875rem;
  margin-left: 3.75rem;
  width: 6.25rem;
}
.teamMain .time {
  font-size: 0.75rem;
}
.teamMain .phone {
  font-size: 0.75rem;
  margin-left: 0.8125rem;
}
.teamMain .avatar {
  width: 1.5625rem;
  height: 1.5625rem;
  border-radius: 0.78125rem;
  background-color: yellow;
}
.teamTop {
  padding-left: 0.9375rem /* 15/16 */;
  padding-right: 0.9375rem;
  height: 2.1875rem /* 35/16 */;
  width: 100%;
  background-color: #fff;
  line-height: 2.1875rem;
  border-bottom: 1px solid #f0f0f0;
}
.teamTop span {
  font-size: 0.8125rem /* 13/16 */;
}
.teamBottoms {
  height: 3.125rem /* 50/16 */;
  width: 23.4375rem /* 375/16 */;
  border-bottom: 1px solid #f3f3f3;
}
.teamBottom {
  height: 3.125rem /* 50/16 */;
  width: 23.4375rem /* 375/16 */;
  border-bottom: 1px solid #f3f3f3;
}
.teamBottom .design {
  margin-right: 0.1875rem /* 3/16 */;
  margin-bottom: 0.625rem /* 10/16 */;
  margin-left: 0.625rem /* 10/16 */;
  display: inline-block;
  width: 1.5rem /* 24/16 */;
  height: 1.5rem /* 24/16 */;
  /* background-color: pink; */
  border-radius: 0.75rem /* 12/16 */;
  background: url("/img/touxiang.png") no-repeat;
  background-size: 100% 100%;
}
.teamTop span {
  margin-bottom: 0.625rem /* 10/16 */;
  font-size: 0.8125rem /* 13/16 */;
}
.teamBottom .mobile {
  display: inline-block;
  height: 2.5rem /* 24/16 */;
  width: 5rem /* 80/16 */;
  /* background-color: pink; */
  margin-bottom: 0.5rem /* 8/16 */;
  font-size: 0.75rem /* 12/16 */;
  vertical-align: middle;
}
.teamBottom .button {
  color: #fff;
  font-size: 0.625rem /* 10/16 */;
  margin-top: 0.78125rem /* 12.5/16 */;
  margin-right: 1rem /* 16/16 */;
  text-align: center;
  line-height: 1.5rem /* 24/16 */;
  /* display: inline-block; */
  width: 3.75rem /* 60/16 */;
  height: 1.5rem /* 24/16 */;
  background-color: #fe5a59;
  border-radius: 0.1875rem /* 3/16 */;
  float: right;
}
.meddie {
  display: inline-block;
  margin-left: 1.875rem /* 30/16 */;
}
.teamBottom .meddie span {
  font-size: 0.75rem /* 12/16 */;
}
.looking {
  height: 2.1875rem /* 35/16 */;
  width: 5.1875rem /* 51/16 */;
  float: right;
}
.teamTop .looks {
  font-size: 0.75rem /* 12/16 */;
  color: #666666;
}
.teamTop .looking {
  font-size: 0.75rem /* 12/16 */;
  color: #666666;
}
.introduce {
  margin-top: 0.3125rem /* 5/16 */;
}
.look {
  height: auto;
  width: 100%;
}
.evaluation {
  /* position: relative; */
  height: 28.75rem /* 460/16 */;
  width: 100%;
  background-color: #fff;
}
.evaluation .p {
  color: #a9a9a9;
  margin-left: 8.125rem /* 130/16 */;
  font-size: 0.8125rem /* 13/16 */;
}
.default {
  /* position: absolute; */
  margin-top: 6.25rem /* 100/16 */;
  margin-left: 8.125rem /* 130/16 */;
  width: 6.59375rem /* 105.5/16 */;
  height: 6.40625rem /* 102.5/16 */;
  background: url("/img/kongzhuangtai.png") no-repeat;
  background-size: 100% 100%;
}
.student {
  padding-right: 0.625rem /* 10/16 */;
  box-sizing: border-box;
  height: 8.75rem /* 140/16 */;
  width: 23.4375rem /* 375/16 */;
  border-bottom: 1px solid #f3f3f3;
}
.student .icon {
  border-radius: 1.875rem;
  width: 1.875rem /* 30/16 */;
  height: 1.875rem /* 30/16 */;
  /* background-color: red; */
  background: url('/img/touxiang.png') no-repeat;
  background-size: 100% 100%;
  margin-top: 0.9375rem /* 15/16 */;
  margin-left: 0.9375rem /* 15/16 */;
  margin-right: 0.9375rem /* 15/16 */;
  display: inline-block;
}
.student .mobile {
  font-size: 0.8125rem /* 13/16 */;
}
.student .time {
  /* float: right; */
  margin-left: 6.875rem /* 110/16 */;
  font-size: 0.75rem /* 12/16 */;
  color: #a9a9a9;
}
.student .comment {
  margin-left: 3.4375rem /* 55/16 */;
  height: 0.75rem /* 12/16 */;
  width: 5.1875rem /* 83/16 */;
}
.student .ping {
  margin-left: 3.4375rem /* 55/16 */;
  font-size: 0.8125rem /* 13/16 */;
  color: #404040;
}
.footers {
  height: 3.75rem /* 60/16 */;
}
.footer {
  margin-top: 3.75rem /* 60/16 */;
  width: 100%;
  height: 3.125rem /* 50/16 */;
  position: fixed;
  bottom: 0;
}
.footer ul p {
  font-size: 0.75rem /* 12/16 */;
}
.footer ul li {
  padding-top: 0.3125rem /* 5/16 */;
  float: left;
  text-align: center;
}
.footer .consult {
  width: 33.33%;
  height: 3.125rem;
  background-color: #fff;
}
.footer .consult .icon {
  width: 1.375rem /* 22/16 */;
  height: 1.375rem /* 22/16 */;
  background-color: #fff;
  background: url("/img/zixunkefu.png") no-repeat;
  background-size: 1.375rem 1.375rem;
  margin-left: 40%;
}
.buyer {
  width: 33.33%;
  height: 3.125rem;
  background-color: #ff9392;
  color: #fff;
}
.buyer p {
  color: #fff;
}
.sponsor {
  width: 33.33%;
  background-color: #fe5a59;
  height: 3.125rem;
  color: #fff;
}
.looksing {
  color: #fff;
  line-height: 3.125rem;
  width: 66.66%;
  height: 3.125rem;
  background-color: #fe5a59;
}
.sponsor p {
  color: #fff;
}
.van-popup {
  /* position: relative; */
  background-color: #fff;
  height: 23.625rem /* 378/16 */;
  width: 18.75rem /* 300/16 */;
  box-sizing: border-box;
}
.van-popup .pt {
  /* top: 0; */
  /* left: 0; */
  /* position: fixed; */
  line-height: 3.75rem;
  height: 3.75rem /* 60/16 */;
  text-align: center;
  width: 18.75rem /* 300/16 */;
  border-bottom: 1px solid #f0f0f0;
}
.now {
  width: 100%;
  height: 20.34375rem /* 325.5/16 */;
  /* background-color:pink; */
}
/* .now .main {

  } */
.now .teamBottom {
  width: 18.75rem /* 300/16 */;
}
.now .meddie {
  margin-left: 0.3125rem /* 5/16 */;
}
.joinnumber {
  color: red;
}
.gap .countdown {
  display: flex;
  font-size: 0.75rem;
}
.gap .countdown .item {
  font-size: 0.75rem;
}
</style>
